import { render, staticRenderFns } from "./InstantViewImages.vue?vue&type=template&id=391e9a8d&"
import script from "./InstantViewImages.vue?vue&type=script&lang=js&"
export * from "./InstantViewImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports